import React, { useMemo } from 'react';
interface PriceDisplayProps {
  amount: number;
  originalAmount?: number;
  className?: string;
}
export function PriceDisplay({
  amount,
  originalAmount,
  className = ''
}: PriceDisplayProps) {
  const currencySymbol = useMemo(() => {
    if (typeof navigator === 'undefined') return '$';
    const locale = navigator.language || 'es';
    if (locale.startsWith('en-GB')) return '£';
    if (locale.startsWith('de') || locale.startsWith('fr') || locale.startsWith('it') || locale.startsWith('nl') || locale.startsWith('pt')) return '€';
    return '$';
  }, []);
  const formatPrice = (price: number) => {
    return price.toFixed(2).replace('.', ',');
  };
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-95">
      {originalAmount && <span className="text-2xl text-gray-400 line-through" data-id="element-96">
          {currencySymbol}
          {formatPrice(originalAmount)}
        </span>}
      <span className="text-5xl md:text-6xl font-bold text-[#7C9A6E]" data-id="element-97">
        {currencySymbol}
        {formatPrice(amount)}
      </span>
    </div>;
}